import { render, staticRenderFns } from "./CargarAspectoCompuesta.vue?vue&type=template&id=0a6f3992&"
import script from "./CargarAspectoCompuesta.vue?vue&type=script&lang=js&"
export * from "./CargarAspectoCompuesta.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports